// extracted by mini-css-extract-plugin
module.exports = {"captcha":"captcha_captcha_OezF3","fanhui":"captcha_fanhui_33bjD"};